import { FormStepID } from '@features/onboarding/enums/formSections.enum';

export type StepText = {
  id?: string;
  title: string;
  description: string;
};

const COMMON_MEDICAL_DESCRIPTION = "We get it—answering questions about medical conditions isn’t exactly a party.  But we need them to process your application. Think of it like an RSVP to great coverage. It’s quick, secure, and we’ll keep it smooth. Let’s knock this out!"
  // 'We get it—answering questions about medical conditions isn’t exactly a party. ' +
  // 'But here’s the scoop: our insurance carriers require this info to process your application. ' +
  // 'It’s like filling out the RSVP for a party you really want to attend (except the “party” is your awesome health coverage). ' +
  // 'Don’t worry, though—it won’t take long, and your answers are protected with top-notch security. ' +
  // 'We’re just here to make the process smooth and stress-free, so let’s get this done and get you covered!';

export const STEP_TEXTS: Record<string, StepText> = {
  initialQuestions: {
    id: FormStepID.PHQ,
    title: 'First up: some quick health questions.',
    description: `This part is what we call the Personal Health Questionnaire (PHQ). Give your best, honest answers; We’ll use them to find the right plans and your exact price. Fast. Private. Done in minutes.`
      // 'Because you have selected a medical plan we have to ask you a few health questions to get to know you better. ' +
      // 'No worries, it’ll only take a few minutes! After that, we can instantly let you know if you are accepted for coverage ' +
      // 'and, if you are, the exact price for the plan of your choice.',
  },
  pregnancy: {
    id: FormStepID.PHQ,
    title: 'First up: some quick health questions.',
    description: `This part is what we call the Personal Health Questionnaire (PHQ). Give your best, honest answers; We’ll use them to find the right plans and your exact price. Fast. Private. Done in minutes.`
      // 'Because you have selected a medical plan we have to ask you a few health questions to get to know you better. ' +
      // 'No worries, it’ll only take a few minutes! After that, we can instantly let you know if you are accepted for coverage ' +
      // 'and, if you are, the exact price for the plan of your choice.',
  },
  takingMedicationsNow: {
    id: FormStepID.Medications,
    title: 'Time to talk about medications.',
    description: '',
  },
  surgeriesDiabetesHeartMental: {
    id: FormStepID.MedicalConditions,
    title: 'Medical conditions.',
    description: COMMON_MEDICAL_DESCRIPTION,
  },
  medDetails: {
    id: FormStepID.MedicalConditions,
    title: 'Medical conditions.',
    description: COMMON_MEDICAL_DESCRIPTION,
  },
  otherHealthConditions: {
    id: FormStepID.MedicalConditions,
    title: 'Medical conditions continued.',
    description: "",
  },
  finalHealthConditions: {
    id: FormStepID.MedicalConditions,
    title: 'Medical conditions.',
    description: COMMON_MEDICAL_DESCRIPTION,
  },
  coverageStartDate: {
    id: FormStepID.EffectiveDate,
    title: 'Choose your effective date.',
    description:
      'Effective date is just a fancy word for when you’d like your coverage to start. ' +
      'Your effective date always starts on the first of the month. We give you 2 options.',
  },
  privacyDisclosure: {
    id: FormStepID.Legal,
    title: 'And now a word from our lawyers.',
    description: 'This section covers important legal information, disclosures, and how we protect your privacy. It’s here to keep things transparent and help you understand your rights and how your information is used. Nothing sneaky—just the facts. Once you click Next, we’ll review your application. Then you’ll see all the plans you choose along with your final quote. You’ll, of course, have the option to make changes before anything is final.',
  },
  congratulations: {
    id: FormStepID.Approved,
    title: 'Congratulations, your  health plan was approved!',
    description: ""
      // "We hope that wasn’t too painful. Just one last thing — we need you to take a quick look at the Personal Health Information (PHI) Disclosure and Client Privacy Notification. " +
      // "These are just standard things we’re required to share with you, and it’s a good idea to give them a quick read.\n\n" +
      // "Once you've had a look, just digitally sign to confirm you’re good with the terms and conditions.\n\n" +
      // "After you hit Submit, we’ll instantly review your application and show you a summary of your plan options and final pricing. " +
      // "From there, you can either move ahead with payment or decide not to continue — totally up to you.\n\n" +
      // "And of course, if you have any questions at all, Alia’s here to help — just reach out!",
  },
};

export function getStepText(stepId: string): StepText {
  return (
    STEP_TEXTS[stepId] || {
      title: 'Medical conditions.',
      description: COMMON_MEDICAL_DESCRIPTION,
    }
  );
}
